import categories from './categories';
import fields from './fields';
import prepopulate from './prepopulate';

export default {
  /**
   * Set up the Algolia credentials
   */
  algolia_app_id: '8VOK4WOPYE',
  algolia_api_key: 'a32630f310e8bde72e07a235bdadda86',
  algolia_index: 'CSG-WORK',

  /**
   * Set up Analytics info for tracking survey responses
   */
  analytics_id: 'UA-130768066-23',

  /**
   * Set up the Google Sheet information so it can make requests to the right place
   */
  google_sheet_title: 'CSG-Workplaces-Employees-2019-DB',

  /**
   * The expiration date of the survey, where no more submissions will be accepted
   * Format: 'July 3, 2019'
   */
  expiration_date: 'December 26, 2018',

  /**
   * Set some variables for the display of the survey
   */
  survey_title: 'Best Workplaces 2019',
  survey_subtitle: null,
  social_title: 'Cast your vote for the Best Workplace in the Colorado Springs area!',
  publication_logo: 'https://s3-us-west-2.amazonaws.com/gazettevoting.com/csg_logo.png',
  welcome_title: 'Welcome!',
  welcome: 'The Colorado Springs Gazette has partnered with DataJoe, an independent research firm, to determine the Colorado Springs area\'s Best Workplaces 2019 through employee surveys.<br><br>In order to participate, companies must receive an employee nomination and then register with the Gazette. DateJoe distributes a unique survey link to registered companies.<br><br>Survey respondents are asked to rate their company in the following areas:<br><br><ul><li>Organizational Health</li><li>Employee Engagement</li><li>Leadership</li><li>Work/Life Balance and Job Benefits</li><li>Social Responsibility</li></ul><br><br>Respondents also have the opportunity to provide comments and additional feedback in each category.<br><br>All responses are anonymous, and results will be tabulated independently by DataJoe.<br><br>Please contact Chris Tumbaga at DataJoe with questions related to the survey\'s methodology or process (surveys@datajoe.com or 720-453-6422).<br><br>Begin filling out the survey below.',
  rules: null,
  categories,
  fields,
  prepopulate,
  votes_per_category: 3,
  write_in_limit: 10,
  vote_requirement: 0,
  about_header: false,
  labels_above: true,
};
